export const QuickLinkActions = {
    SET_SMART_FILTER: 'SET_SMART_FILTER',
}

export const setSmartFilterQuickLink = (value: any) => {
    return { type: QuickLinkActions.SET_SMART_FILTER, value }
}



